import { render, staticRenderFns } from "./ObjectPageContainer.vue?vue&type=template&id=4cb1e278&"
import script from "./ObjectPageContainer.vue?vue&type=script&lang=js&"
export * from "./ObjectPageContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports